import { HttpClient, HttpEventType } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OidcSecurityService, UserDataResult } from 'angular-auth-oidc-client';
import { flatMap, forkJoin, Observable, of, map, mergeMap } from 'rxjs';
import { DaoService } from '../../../core/dao/dao.service';
import { Toast, ToastrService } from 'ngx-toastr';
import { ITileItem, TileItem } from '../../../core/models/tile-item.model';
import { AudioProcessorTask, AudioProcessorTaskBlock, IAudioProcessorTask, IAudioProcessorTaskBlock, IWorkerStatus } from '../../../core/models/audio-processor-task.model';
import { IAudioPlugin } from '../../../core/models/plugin.model';
import { TaskViewerModel } from './task.viewer.model';
import { AsyncService } from '../../../core/async/async.service';
import { faL } from '@fortawesome/free-solid-svg-icons';
import { NotificationService } from '../../../core/hubs/notification.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { faMagnifyingGlass, faRecycle, faDownload, faList, faTrash } from '@fortawesome/free-solid-svg-icons';
import { TaskModel } from '../task.model';


@Component({
  selector: 'app-task-viewer',
  templateUrl: 'task.viewer.component.html',
  styleUrls: ['task.viewer.component.scss']
})
export class TaskViewerComponent implements OnInit {

  public searchString: string = "";
  faMagnifyingGlass = faMagnifyingGlass;
  faRecycle = faRecycle;
  faDownload = faDownload;
  faList = faList;
  faTrash = faTrash;
  viewMode = "tile";
  taskGridColumns = [
    {
      dataField: "name",
      allowEditing: true
    },
    {
      dataField: "timestamp",
      allowEditing: true
    },
    {
      dataField: "lastUpdate",
      allowEditing: true
    },
    {
      dataField: "progress",
      allowEditing: true
    },
    {
      dataField: "status",
      allowEditing: true
    },
    {
      dataField: "statusMessage",
      allowEditing: true,
      width: 250
    },
    {
      dataField: "downloadUrl",
      allowEditing: true,
      width: 200
    }
  ]

  constructor(
    private dao: DaoService,
    private toastr: ToastrService,
    public taskViewerModel: TaskViewerModel,
    public taskModel: TaskModel,
    public async: AsyncService,
    public notificationService: NotificationService,
    private loader: NgxUiLoaderService) {
    notificationService.startConnection(this);
  }

  ngOnInit() {
    this.refresh(true);
  }

  onCreated(data: any) {
    this.refresh(true);
  }

  onCompleted(data: any) {
    this.refresh(false);
  }

  onError(data: any) {
    this.refresh(false);
  }

  onUpdate(data: any) {
    data = JSON.parse(data);
    let tasks = this.taskViewerModel.tasks.filter(item => { return item.id === data.taskId });
    if (tasks.length) {
      let task = tasks[0];
      let block = task.taskBlocks.filter(item => { return item.id === data.blockId })[0];
      task.progress = data.progress;
      task.status = data.taskStatus
      block.status = data.blockStatus;
    }
  }

  refresh(enableLoading: boolean) {
    if (enableLoading) this.loader.start();

    this
      .dao
      .GetCurrentUserTasks()
      .subscribe(
        result => {
          let tasks = result.sort((a, b) => {
            if (a.timestamp > b.timestamp) return -1;
            if (a.timestamp < b.timestamp) return 1;
            return 0;
          });

          for (let t in tasks) {
            let task = tasks[t];
            for (let b in task.taskBlocks) {
              let block = task.taskBlocks[b];
              let plugin = this.taskModel.plugins.filter(item => { return item.id === block.pluginId })[0];
              if (plugin)
                block.plugin = plugin;
            }
          }

          this.taskViewerModel.tasks = tasks;
        }, error => {
          this.toastr.error("There was an error getting your task history, please refresh the page and try again");
        }, () => {
          this.loader.stop();
        })
  }

  cancelTask($event: Event, task: IAudioProcessorTask) {

    this
      .dao
      .GetTask(task.id)
      .subscribe((result) => {
        let message;
        if (result.status == IWorkerStatus.DONE || result.status == IWorkerStatus.ERROR) {
          message = "Are you sure you want to delete this task?"
        } else {
          message = "You are about to stop processing this task and deleting it. Are you sure?";
        }
        this
          .async
          .openDialog("Cancel Task", message, (result) => {
            if (result) {
              this.loader.start();
              this
                .dao
                .DeleteTask(task.id)
                .subscribe(() => {
                  this.taskViewerModel.removeTask(task);
                  this.toastr.success("The task has been successfully canceled");
                }, err => {
                  this.toastr.error(err.message);
                }, () => {
                  this.loader.stop();
                })
            }
          })

      });

  }

}
